import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { CreateClientMarketItchConnectionMutationResponse, CreateClientMarketItchConnectionPathParams, CreateClientMarketItchConnection400 } from "../types/CreateClientMarketItchConnection";
import type { UseMutationOptions } from "@tanstack/react-query";

 type CreateClientMarketItchConnectionClient = typeof client<CreateClientMarketItchConnectionMutationResponse, CreateClientMarketItchConnection400, never>;
type CreateClientMarketItchConnection = {
    data: CreateClientMarketItchConnectionMutationResponse;
    error: CreateClientMarketItchConnection400;
    request: never;
    pathParams: CreateClientMarketItchConnectionPathParams;
    queryParams: never;
    headerParams: never;
    response: CreateClientMarketItchConnectionMutationResponse;
    client: {
        parameters: Partial<Parameters<CreateClientMarketItchConnectionClient>[0]>;
        return: Awaited<ReturnType<CreateClientMarketItchConnectionClient>>;
    };
};
/**
 * @description Creates a new ITCH connection for a clients market
 * @summary Create ITCH connection
 * @link /api/clients/:clientCode/markets/:marketCode/connections/itch
 */
export function useCreateClientMarketItchConnection(clientCode: CreateClientMarketItchConnectionPathParams["clientCode"], marketCode: CreateClientMarketItchConnectionPathParams["marketCode"], options: {
    mutation?: UseMutationOptions<CreateClientMarketItchConnection["response"], CreateClientMarketItchConnection["error"], CreateClientMarketItchConnection["request"]>;
    client?: CreateClientMarketItchConnection["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async () => {
            const res = await client<CreateClientMarketItchConnection["data"], CreateClientMarketItchConnection["error"], CreateClientMarketItchConnection["request"]>({
                method: "post",
                url: `/api/clients/${clientCode}/markets/${marketCode}/connections/itch`,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}